import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ApprovedRoute() {
  const { currentUser, isApprovedUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace state={{ returnTo: window.location.pathname }} />;
  }

  return isApprovedUser ? <Outlet /> : <Navigate to="/workspace" replace />;
}

export default ApprovedRoute;
